(function ($) {
    'use strict';

    var guestcheckoutform = $("#frmGuest");
    var guestcheckoutpay = $("#btnGuestPayment");
    var termsCheckbox = $("#Terms");

    if (guestcheckoutpay.length > 0) {
        
        guestcheckoutpayclick(guestcheckoutpay, guestcheckoutform);
    }

    function guestcheckoutpayclick(button, form) {
        var $button = $(button);
        var $form = $(form);
        $button.click(function (e) {
            var $this = $(this);
            if (termsCheckbox.length > 0 && !termsCheckbox.is(":checked")) {
                $('input[name=Terms]').trigger('change').prop('checked', false);
            } else {
                if (e.isDefaultPrevented()) {
                    $form.validator('validate');
                    return;
                } else {
                    e.preventDefault();
                    if ($("#chkOptIn").is(':checked'))
                        $("#SendOffers").val(true); // checked
                    if (termsCheckbox.is(':checked')){
                        $("#TermsHidden").val(true); //checked
                    }

                    $form.submit();
                }
            }
        });
    }
})($jq);
